import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { DTFService } from "../../dtf.service";
import { Banner } from "../../shared/models/banner";
import { AuthorizationService } from "../authorization/authorization.service";
import { WindowRef } from '../../utils/window';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { TranslateUtil } from '../../utils/translate-util';
import { DTFHomepageService } from '../dtfhomepage/dtfhomepage.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { SharedTranslateModule } from "../../utils/sharedTranslateModule";


export interface Element {
  name: string;
  position: number;
  Loan: string;
  TRACLease: string;
  ModifiedTRACLease: string;
  ZeroTRACLease: string;
  FMVLease: string;
}

@Component({
    selector: "div.dtf-financeleasesolutions",
    templateUrl: './financeleasesolutions.component.html',
    imports: [SharedTranslateModule],
    providers: [
    //  ClassesUtil, WindowRef
    ]
})
export class FinanceLeaseSolutionsComponent implements OnInit {
  router: Router;
  isCanadaPortal = false;
  isFrench = false;
  isCanadaFrench = false;
  isCanadaEnglish = false;
  currentCountry: string;
  language = '';
  targetRedirect = '';
  usUrl: string;
  caUrl: string;
  toggleOpen: any;
  public alerts: Banner;
  dbData: any;
  

  name: string;
  position: number;
  Loan: string;
  TRACLease: string;
  ModifiedTRACLease: string;
  ZeroTRACLease: string;
  FMVLease: string;

  initColumns: Element[] = [
    {
      position: 1,
      name: 'Lower Payments',
      Loan: '',
      TRACLease: 'X',
      ModifiedTRACLease: 'X',
      ZeroTRACLease: 'X',
      FMVLease: 'X',
    },
    {
      position: 2,
      name: 'Minimal up-front cash outlay',
      Loan: '',
      TRACLease: 'X',
      ModifiedTRACLease: 'X',
      ZeroTRACLease: 'X',
      FMVLease: 'X',
    },
    {
      position: 3,
      name: 'Payments qualify as operating expense on income statement',
      Loan: '',
      TRACLease: '',
      ModifiedTRACLease: 'X',
      ZeroTRACLease: '',
      FMVLease: 'X',
    },
    {
      position: 4,
      name: 'Walk-away lease',
      Loan: '',
      TRACLease: '',
      ModifiedTRACLease: '',
      ZeroTRACLease: '',
      FMVLease: 'X',
    },
    {
      position: 5,
      name: 'Avoids obsolecense risk',
      Loan: '',
      TRACLease: 'X',
      ModifiedTRACLease: 'X',
      ZeroTRACLease: 'X',
      FMVLease: 'X',
    },
    {
      position: 6,
      name: 'No Residual risk',
      Loan: '',
      TRACLease: '',
      ModifiedTRACLease: '',
      ZeroTRACLease: 'X',
      FMVLease: 'X',
    },
    {
      position: 7,
      name: 'No mileage restrictions',
      Loan: 'X',
      TRACLease: 'X',
      ModifiedTRACLease: 'X',
      ZeroTRACLease: 'X',
      FMVLease: '',
    },
    {
      position: 8,
      name: 'Retains tax depreciation benefits',
      Loan: 'X',
      TRACLease: '',
      ModifiedTRACLease: '',
      ZeroTRACLease: '',
      FMVLease: '',
    },
    {
      position: 9,
      name: 'Payments deductible as operating expense for tax purposes',
      Loan: '',
      TRACLease: 'X',
      ModifiedTRACLease: 'X',
      ZeroTRACLease: '',
      FMVLease: 'X',
    },
    {
      position: 10,
      name: 'Can be structured as Dynamic lease',
      Loan: '',
      TRACLease: 'X',
      ModifiedTRACLease: 'X',
      ZeroTRACLease: '',
      FMVLease: 'X',
    },
  ];

  columns = [
    {
      columnDef: 'name',
      header: '',
      mobileHeader: 'Name',
      headerFR: '',
      cell: (element: Element) => `${element.name}`,
    },
    {
      columnDef: 'Loan',
      header: 'Loan',
      mobileHeader: 'Loan',
      headerFR: 'Loan',
      cell: (element: Element) => `${element.Loan}`,
    },
    {
      columnDef: 'TRACLease',
      header: 'TRAC Lease',
      mobileHeader: 'Trac Lease',
      headerFR: 'TRAC Lease',
      cell: (element: Element) => `${element.TRACLease}`,
    },
    {
      columnDef: 'ModifiedTRACLease',
      header: 'Modified TRAC Lease',
      mobileHeader: 'Modified Trac Lease',
      headerFR: 'Modified TRAC Lease',
      cell: (element: Element) => `${element.ModifiedTRACLease}`,
    },
    {
      columnDef: 'ZeroTRACLease',
      header: 'Zero TRAC Lease',
      mobileHeader: 'Zero Trac Lease',
      headerFR: 'Zero TRAC Lease',
      cell: (element: Element) => `${element.ZeroTRACLease}`,
    },
    {
      columnDef: 'FMVLease',
      header: 'FMV Lease',
      mobileHeader: 'FMV Lease',
      headerFR: 'FMV Lease',
      cell: (element: Element) => `${element.FMVLease}`,
    },
  ];

  dataSource = this.initColumns;
  displayedColumns = this.columns.map(c => c.columnDef);

  constructor(
    router: Router,
    public translate: TranslateService,
    private _window: WindowRef,
    public dtfhomepageService: DTFHomepageService,
    public translateUtil: TranslateUtil
  ) {
    this.router = router;
}
  ngOnInit() {
    const language = (window as any).mbfs.language;
    this.isFrench = ('fr-CA' === language) ? true : false; //checks if language is french or english for Canada
    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
    });
    if (!this.isFrench && this.isCanadaPortal) {
      this.isCanadaEnglish = true;
    }
    if (this.isFrench && this.isCanadaPortal) {
      this.isCanadaFrench = true;
    }
    //this.getAlerts();
    this.langInit();
  }

  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

  langInit() {
    // Initializes Language and all URL's for href
    this.language = (this._window.nativeWindow as any).mbfs.language;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;

    // Checks if what language user is to redirect to correct href in link nav
    if (this.language === 'en-CA') {
        this.targetRedirect = this.usUrl + '/ca/en/home/';
    } else if (this.language === 'fr-CA') {
        this.targetRedirect = this.usUrl + '/ca/fr/home/';
    } else {
        this.targetRedirect = this.usUrl + '/home/';
    }
  }

  // getAlerts() {
  //   this.dtfhomepageService.getAlerts().subscribe((res) => {
  //       for (var i = 0; i < res.length; i++) {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //     });
  // }


}
